import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Card } from '@ui5/webcomponents-react';
import { useTheme } from '../utils/ThemeContext';

export default function HolePanel({
  holeNumber,
  par,
  menHcp,
  womenHcp,
  score,
  decrementDisabled,
  incrementDisabled,
  display,
  sliderDirection,
  sliderIn,
  onDecrement,
  onIncrement,
  onPrev,
  onNext,
}) {
  const { theme } = useTheme();
  return (
    <>
      <Slide direction={sliderDirection} in={sliderIn} timeout={{ enter: 500, exit: 500 }} mountOnEnter unmountOnExit>
        <Container>
          <Card>
            <Box display={display} justifyContent="center" alignItems="center" flexDirection="column" pt={2} pb={1}>
              <Box style={{ fontSize: '1.5em', fontWeight: 'bold', color: theme.primary }}>
                Hole {holeNumber}
              </Box>
              <Box style={{ fontSize: '0.9em', color: '#555' }}>
                Par: {par} &nbsp;|&nbsp; M/W Hcp: {menHcp}/{womenHcp}
              </Box>
            </Box>
            <Box display={display} justifyContent="center" alignItems="center" pb={2}>
              <IconButton
                size="medium"
                disabled={decrementDisabled}
                onClick={onDecrement}
                style={{ color: decrementDisabled ? '#ccc' : theme.primary }}
              >
                <RemoveCircleOutlineIcon fontSize="large" />
              </IconButton>
              <Box style={{ fontSize: '3em', fontWeight: 'bold', color: theme.primary, minWidth: '60px', textAlign: 'center' }}>
                {score}
              </Box>
              <IconButton
                size="medium"
                disabled={incrementDisabled}
                onClick={onIncrement}
                style={{ color: incrementDisabled ? '#ccc' : theme.primary }}
              >
                <AddCircleOutlineIcon fontSize="large" />
              </IconButton>
            </Box>
          </Card>
        </Container>
      </Slide>
      <Box display={display} justifyContent="space-between" alignItems="center" pt={2} pl={4} pr={4}>
        <Button
          variant="outlined"
          disabled={!onPrev}
          onClick={onPrev}
          style={{ borderColor: onPrev ? theme.primary : '#ccc', color: onPrev ? theme.primary : '#ccc', minWidth: '48px' }}
        >
          ←
        </Button>
        <Button
          variant="outlined"
          disabled={!onNext}
          onClick={onNext}
          style={{ borderColor: onNext ? theme.primary : '#ccc', color: onNext ? theme.primary : '#ccc', minWidth: '48px' }}
        >
          →
        </Button>
      </Box>
    </>
  );
}
